<template>
    <v-card>
        <v-card-title class="sub-heading black--text">
            Select Group by for {{selectedGroupColumn.name}}
             <v-spacer />
            <v-icon @click="closeDialog()" small class="grey--text">fas fa-times</v-icon>
        </v-card-title>
        <v-card-text>
             <v-autocomplete
                :items="setGroupTotal"
                class="style-input mr-2 pt-1"
                outline
                hide-details
                item-text="name"
                item-value="id"
                multiple                
                chips
                small-chips
                clearable
                deletable-chips
                @change="triggerValue"
                v-model="selectedColumn"
            ></v-autocomplete>
        </v-card-text>
    </v-card>
</template>
<script>
export default {
    props:["setGroupTotal", "selectedGroupColumn"],
    data(){
        return{
            selectedColumn:[]
        }
    },
    watch:{
       selectedGroupColumn(){
            this.selectedColumn = this.selectedGroupColumn.subtotal
       }
    },
    created:function(){
        this.selectedColumn = this.selectedGroupColumn.subtotal
    },
    methods:{
        triggerValue(){
            this.selectedGroupColumn.subtotal = this.selectedColumn
            this.$emit('selectedGroup', this.selectedGroupColumn)
        },
        closeDialog(){
            this.$emit('closeDialog',true)
        }
    }
}
</script>